import React from "react"
import { graphql, Link } from "gatsby" //highlight-line
import Layout from "../components/layout"
import SEO from "../components/seo"
import StoryItemTall from "../components/story-item-tall"
import BlogItem from "../components/blog-item"
import { StaticImage } from "gatsby-plugin-image"
import { FaArrowRight } from "react-icons/fa"

function CustomHeader() {
  return (
    <div className={"w-full"}>
      <div style={{ display: "grid" }}>
        {/* You can use a GatsbyImage component if the image is dynamic */}
        <StaticImage
          className={"hidden 2xl:block"}
          style={{
            gridArea: "1/1",
            // You can set a maximum height for the image, if you wish.
            // maxHeight: 600,
          }}
          layout="fullWidth"
          placeholder="blurred"
          // You can optionally force an aspect ratio for the generated image
          aspectRatio={5 / 1}
          // This is a presentational image, so the alt should be an empty string
          alt="Welcome To Our Stories"
          // Assisi, Perúgia, Itália by Bernardo Ferrari, via Unsplash
          src={"../images/bg.jpg"}
          backgroundColor={"black"}
          formats={["auto", "webp", "avif"]}
        />
        <StaticImage
          className={"hidden md:block 2xl:hidden"}
          style={{
            gridArea: "1/1",
            // You can set a maximum height for the image, if you wish.
            // maxHeight: 600,
          }}
          layout="fullWidth"
          // You can optionally force an aspect ratio for the generated image
          aspectRatio={3 / 1}
          placeholder="blurred"
          // This is a presentational image, so the alt should be an empty string
          alt="Welcome To Our Stories"
          // Assisi, Perúgia, Itália by Bernardo Ferrari, via Unsplash
          src={"../images/bg.jpg"}
          backgroundColor={"black"}
          formats={["auto", "webp", "avif"]}
        />
        <StaticImage
          className={"block md:hidden"}
          style={{
            gridArea: "1/1",
            // You can set a maximum height for the image, if you wish.
            // maxHeight: 600,
          }}
          layout="fullWidth"
          // You can optionally force an aspect ratio for the generated image
          aspectRatio={3 / 2}
          placeholder="blurred"
          // This is a presentational image, so the alt should be an empty string
          alt="Welcome To Our Stories"
          // Assisi, Perúgia, Itália by Bernardo Ferrari, via Unsplash
          src={"../images/bg.jpg"}
          backgroundColor={"black"}
          formats={["auto", "webp", "avif"]}
        />
        <div
          style={{
            // By using the same grid area for both, they are stacked on top of each other
            gridArea: "1/1",
            position: "relative",
            // This centers the other elements inside the hero component
            placeItems: "center",
            display: "grid",
          }}
        >
          {/* Any content here will be centered in the component */}
          <p
            className={
              "py-4 w-4/5 lg:w-1/2 text-center text-white dark:text-white text-xl md:text-4xl font-bold"
            }
          >
            Stimulate imagination, concentration and inspiration with these
            classic fairy tales and bedtime stories.
          </p>
        </div>
      </div>
    </div>
  )
}

export default function Home({ data }) {
  return (
    <Layout sb={false} mt={"mt-12"} customHeader={<CustomHeader />}>
      <SEO
        website={true}
        title="Bedtime Stories and Fairy Tales"
        description={`Free kid friendly bedtime stories and fairy tales for all ages.`}
        url={`${process.env.GATSBY_SITE_URL}`}
      />
      <p className={"mx-auto max-w-2xl text-center text-lg pb-4 mt-4"}>
        <strong>Nighty Night Stories</strong> is a place to find kid friendly
        and modern takes on classic fairy tales. All our stories have been
        edited by our team to ensure a clean and fun place to learn and explore.
      </p>
      <p className={"mx-auto max-w-2xl text-center text-lg pb-8 mt-4"}>
        Take a quiz or share a comment to further involve your child in these
        fantastic bed time stories.
      </p>

      <div className={"w-full"}>
        <h2 className={"text-3xl  lg:text-6xl  mb-12 text-center"}>
          Choose A Bedtime Story
        </h2>
        <div className={"grid md:grid-cols-12 md:gap-10 mb-12"}>
          {data.allWpStory.nodes.map(node => (
            <StoryItemTall key={node.slug} post={node} />
          ))}
        </div>
      </div>
      <h2 className={"text-md font-bold mb-4 text-center sm:text-left "}>
        Latest from our Blog
      </h2>
      {data.allWpPost.nodes.map(node => (
        <BlogItem key={node.slug} post={node} />
      ))}
      <p className={"text-center md:text-right"}>
        <Link to={"/blog"} className={"inline"}>
          View More <FaArrowRight className={"inline"} />
        </Link>
      </p>
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    allWpStory(sort: { fields: [title] }) {
      nodes {
        ...story
      }
    }
    allWpPost(sort: { order: DESC, fields: date }, limit: 3) {
      nodes {
        ...post
      }
      distinct(field: commentCount)
    }
  }
`
